module.exports = __webpack_public_path__ + "img/SEARCH.5ddb16ef.svg";